import { PNL_CUBE_MONTH_COLUMN, PNL_CUBE_SCENARIO_COLUMN } from 'src/components/star-grid/starGridConstants';
import { PnlQueryRequest } from 'src/components/star-grid/starGridTypes';

/** Historical fact queries require explicit period grouping; Live adds it in the API. */
export const pnlQueryPayload = (request: PnlQueryRequest): PnlQueryRequest =>
  request.as_of_timestamp ? { ...request, group_by: [...new Set([...request.group_by, PNL_CUBE_SCENARIO_COLUMN, PNL_CUBE_MONTH_COLUMN])] } : request;
